import type { PetLossLocale } from '@paction-2.0/util/petLossReadiness';

export type ReadinessUiCopy = {
  aboutHeading: (practiceName: string) => string;
  begin: string;
  seeResult: string;
  startOver: string;
  consentLabel: string;
  consentDescription: string;
};

export const READINESS_UI_COPY: Record<PetLossLocale, ReadinessUiCopy> = {
  en: {
    aboutHeading: (practiceName) => `About ${practiceName}`,
    begin: 'Get Started',
    seeResult: 'See my result',
    startOver: 'Start over',
    consentLabel: 'Share my answers anonymously',
    consentDescription:
      'Helps pet loss research. Only your answers and result are saved — no name, email or contact details.'
  },
  fr: {
    aboutHeading: (practiceName) => `À propos de ${practiceName}`,
    begin: 'Commencer',
    seeResult: 'Voir mon résultat',
    startOver: 'Recommencer',
    consentLabel: 'Partager mes réponses de façon anonyme',
    consentDescription:
      'Aide la recherche sur le deuil animalier. Seuls vos réponses et votre résultat sont enregistrés — aucun nom, courriel ou coordonnée.'
  }
};
